var emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);

import { emailAvailable } from './api/calls'

export default function(newVal, oldVal){
  this.pristine = newVal == '' ? true : false;
  let passesRegex = emailRegex.test(newVal);

  //Test for . in extension, which technically doesn't need to be there to pass RFC definition of valid email,
  //but which for all practical purposes should be there
  let split = newVal.split('@');
  let last = split.pop();

  if(passesRegex && last.indexOf('.') > -1){
    this.checkingEmailAvailable = true;
    emailAvailable(newVal).then(function(response){
      this.checkingEmailAvailable = false;
      if(response.taken){
        this.emailTaken = true;
        this.validEmail = false;
      } else {
        this.emailTaken = false;
        this.validEmail = true;
      }
    }.bind(this));
  }
}



// WEBPACK FOOTER //
// ./src/lib/EmailField.js